import { Color } from "../enums/Color"
import { commonHeader } from "./CommonHeader"

export const lowHeader = {
    mobile: {
        ...commonHeader.mobile,
        row: {
            display: "flex",
            flexDirection: "row" as "row",
            position: "relative"
        },
        header: {
            background: Color.Blue,
            marginTop: "0%",
            marginLeft: "0%",
            width: "100%",
            height: "48.30vw",
            opacity: "1",
            position: "relative"
        },
        longBuildingSvg: {
            position: "absolute" as "absolute",
            right: "0",
            bottom: "0",
            width: "80%"
        },
        recruitersButton: {
            color: Color.White,
            fontWeight: "bold" as "bold",
            backgroundColor: Color.DeepBlack,
            border: "none",
            WebkitTapHighlightColor: "transparent",
            position: "relative" as "relative",
            marginRight: "1.04vw",
            marginTop: "2.08vw",
            marginLeft: "0px",
            transform: "none",
            width: "15vw",
            fontSize: "1.04vw",
            borderRadius: "0.6vw",
            height: "3.64vw",
            display: "none"
        },
        jobSeekersButton: {
            color: Color.White,
            fontWeight: "bold" as "bold",
            backgroundColor: Color.Green,
            border: "none",
            cursor: "pointer",
            WebkitTapHighlightColor: "transparent",
            position: "relative" as "relative",
            marginRight: "2.60vw",
            marginTop: "2.08vw",
            marginLeft: "0px",
            transform: "none",
            width: "15vw",
            fontSize: "1.04vw",
            borderRadius: "0.6vw",
            height: "3.64vw",
            display: "none"
        },
        heading: {
            position: "relative" as "relative",
            left: "50%",
            transform: "translate(-50%, 0%)",
            width: "70.28vw",
            height: "6.76vw",
            marginTop: "12.07vw",
            marginBottom: "auto",
            textAlign: "center" as "center",
            fontWeight: "bold" as "bold",
            fontSize: "6.03vw",
            letterSpacing: "0px",
            color: Color.White,
            opacity: "1",
            moveDown: {
                marginTop: "5vh"
            }
        },
        text: {
            position: "relative" as "relative",
            left: "50%",
            transform: "translate(-50%, 0%)",
            width: "90%",
            height: "12.16vh",
            marginTop: "1.35vh",
            textAlign: "center" as "center",
            fontSize: "3.33vw",
            letterSpacing: "0px",
            color: Color.White,
            opacity: "1"
        },
        jobTitleWrapper: {
            display: "none"
        }
    },
    desktop: {
        ...commonHeader.desktop,
        header: {
            height: "18.020vw"
        },
        desktopImageLeft: {
            display: "none"
        },
        recruitersButton: {            
            display: "inline"
        },
        jobSeekersButton: {
            display: "inline"
        },
        heading: {
            width: "auto",
            marginTop: "4.37vw",
            height: "unset",
            marginBottom: "1vh",
            fontSize: "2.6vw",
            moveDown: {
                marginTop: "3.60vw"
            }
        },
        text: {
            width: "70%",
            height: "12.8vh",
            textAlign: "center" as "center",
            fontFamily: "Poppins",
            fontSize: "0.83vw",
            letterSpacing: "0px",
            color: Color.White,
            opacity: "1"
        }
    }
}
